module.exports = __webpack_public_path__ + "static/media/beneficios.a4f59855.png";